import { Breadcrumb, Tabs } from "antd";
import React from "react";
import { _adr } from "../../../../address";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { HomeOutlined } from "@ant-design/icons";
import styles from "./dealerRequestKits.module.scss";
import NewRequest from "./newRequest";
import SubmitedRequest from "./submitedRequest";
const DealerRequestKits = () => {
	const [t] = useTranslation("global");
	return (
		<div className="container-main container-cw">
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simLocked.newRequest") }]}
					/>
					<div className="title-page">
						<h3>{t("simLocked.newRequest")}</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className={styles.holder_new_request}>
							<Tabs
								rootClassName={styles.customtab}
								defaultActiveKey="new_request"
								items={[
									{
										key: "new_request",
										label: "درخواست جدید",
										children: <NewRequest t={t} />,
									},
									{
										key: "request_submited",
										label: "درخواست ثبت شده",
										children: <SubmitedRequest />,
									},
								]}
							/>
						</div>
					</div>
				</Content>
			</div>
		</div>
	);
};

export default DealerRequestKits;
